/* SPDX-FileCopyrightText: 2014-present Kriasoft */
/* SPDX-License-Identifier: MIT */

import { Button } from "@mui/joy";
import { Link } from "react-router-dom";

interface CreateNewButtonProps {
  children: React.ReactNode;
  to?: string;
  onClick?: () => void;
  startDecorator?: React.ReactNode;
  sx?: any;
}

export function CreateNewButton({
  children,
  to,
  onClick,
  startDecorator,
  sx,
}: CreateNewButtonProps): JSX.Element {
  const buttonSx = {
    transition: "transform 0.2s ease-in-out",
    "&:hover": {
      transform: "scale(1.05)",
    },
    "&:active": {
      transform: "scale(0.95)",
    },
    fontSize: "0.95rem",
    px: 4,
    py: 1,
    minWidth: "120px",
    whiteSpace: "nowrap" as const,
    overflow: "hidden" as const,
    textOverflow: "ellipsis" as const,
    ...sx,
  };

  if (to) {
    return (
      <Button
        component={Link}
        to={to}
        variant="solid"
        color="primary"
        startDecorator={startDecorator}
        sx={buttonSx}
        size="md"
      >
        {children}
      </Button>
    );
  }

  return (
    <Button
      variant="solid"
      color="primary"
      startDecorator={startDecorator}
      onClick={onClick}
      sx={buttonSx}
      size="md"
    >
      {children}
    </Button>
  );
}
